// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tbl_search th[data-v-788f845c] {vertical-align: top;}\n.txt_desc1[data-v-788f845c] {\n  font-family: 'Courier New';\n  width: 800px;\n}\n.crtfNo[data-v-788f845c]{\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
